@use '../../style/functions';

/**
 * @prop --banner-icon-fill-color: Color of the banner icon.
 * @prop --banner-icon-background-color: Background color of the banner icon.
 */

.lime-banner {
    min-height: 3.25rem;
    display: none;
    background-color: rgba(var(--contrast-100), 0.7);
    backdrop-filter: blur(functions.pxToRem(5));
    box-shadow: var(--shadow-depth-16);

    &.lime-banner--open {
        display: block;
        .lime-banner__surface {
            opacity: 1;
        }
    }
    .lime-banner__surface {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        opacity: 0;
    }

    .lime-banner__content {
        display: flex;
        align-items: center;
        align-content: stretch;
        padding: functions.pxToRem(16);
        flex-wrap: wrap;
    }

    .icon-message {
        display: flex;
        align-items: center;
    }

    div[class^='mdc-typography'] {
        color: rgb(var(--contrast-1200));
    }

    .lime-banner__icon {
        margin: 0 functions.pxToRem(10);
        align-self: flex-start;
    }

    .lime-banner__actions {
        margin-left: functions.pxToRem(50);
        display: flex;
        justify-content: flex-end;
    }

    limel-icon {
        color: var(--banner-icon-fill-color, rgb(var(--contrast-100)));
        background-color: var(
            --banner-icon-background-color,
            rgb(var(--contrast-800))
        );
    }
}
@media screen and (max-width: 760px) {
    .lime-banner__content {
        flex-direction: column;
        gap: 0.5rem;
    }
    .icon-message {
        display: flex;
        align-items: center;
    }
    .lime-banner__actions {
        margin-left: 0;
    }
}
